import { SET_TRIAL_VERSION } from "../constants/action-types";

export default (state = false, { type, trialVersion }) => {
  if (type == SET_TRIAL_VERSION) {
    return trialVersion;
  } else {
    return state;
  }
};
